import { setActiveRoute } from "../setActiveRoute/setActiveRoute";
import { buildUrlFrom } from "../../../lib/routes";

export const goToRoute = (params, replaceHistory = false) => {
  return (dispatch, getState) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.delete("page");

    // If no params is provided
    if (!params) {
      return dispatch(setActiveRoute({ pageName: "domainSearch" }));
    }

    const pageName = params.pageName;

    const add = replaceHistory ? "replaceState" : "pushState";

    window.history[add](
      null,
      pageName,
      buildUrlFrom({
        pageName,
        searchParams,
        hash: window.location.hash !== "#" ? window.location.hash : "",
      }),
    );

    dispatch(setActiveRoute({ pageName }));
  };
};
